
import { futureLeg } from '../paf-result-pearl-chain/paf-result-pearl-chain.sample-data';

import { InterfaceResultTimetableRow } from './paf-result-timetable-row.custom';

export const defaultJourneyId = '1234abcd';

export const defaultJourney: InterfaceResultTimetableRow = {
  date: '2024-12-29',
  heading: 'Abfahrt: 12:11, Gl. 1, Zug IC 80, Richtung Bierhübeli',
  headingLevel: '3',
  id: defaultJourneyId,
  link: {
    aLabelValue: 'Tickets und Reservationen (Absprung zu sbb.ch. Öffnet sich in einem neuen Fenster',
    disabled: false,
    href: 'https://www.sbb.ch',
    isLink: true,
    target: '_blank',
    text: 'Tickets und Reservationen',
    variant: 'primary',
  },
  pearlChain: {
    legs: JSON.stringify([futureLeg]),
    now: 1669893060,
    orientation: 'horizontal',
  },
  pearlChainTime: {
    arrivalTime: '2022-12-11T14:11:00',
    arrivalWalk: 4,
    departureTime: '2022-12-11T12:11:00',
    departureWalk: 0,
  },
  priceBadge: {
    isDiscount: false,
    priceText: 'ab CHF 2.80',
  },
  rowFooter: {
    attributeIcons: JSON.stringify([
      {
        name: 'sa-rs',
      },
      {
        name: 'sa-rr',
      },
    ]),
    cusHimIcons: JSON.stringify(['info']),
    duration: '1 h 45 min',
    hasPlatformChange: false,
    occupancyClassOne: 'low',
    occupancyClassTwo: 'medium',
    platform: 'Gl. 1',
  },
  rowHeader: {
    direction: 'Richtung Bierhübeli',
    level: '1',
    picto: 'train-right',
    productIcon: 'ic-80',
    productText: 'B11',
  },
  summary: 'Some hidden summary',
};
